import React, { useState, useEffect } from "react";
import { Table, Button, Modal, Form, Input, message, Space } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";

const ClientPage = () => {
  const [clients, setClients] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentClient, setCurrentClient] = useState(null);
  const [form] = Form.useForm();

  useEffect(() => {
    // Моковые данные с номером документа вместо ID
    const mockClients = [
      {
        docNumber: "1234567890",
        name: 'ООО "ТехноПром"',
        phone: "+7 (123) 456-78-90",
        address: "г. Москва, ул. Ленина, д. 10",
      },
      {
        docNumber: "0987654321",
        name: "ИП Иванов А.А.",
        phone: "+7 (987) 654-32-10",
        address: "г. Санкт-Петербург, Невский пр-т, д. 25",
      },
      {
        docNumber: "5551234567",
        name: 'ЗАО "СтройМатериалы"',
        phone: "+7 (555) 123-45-67",
        address: "г. Екатеринбург, ул. Гагарина, д. 42",
      },
    ];
    setClients(mockClients);
  }, []);

  const columns = [
    {
      title: "Название компании",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Номер документа",
      dataIndex: "docNumber",
      key: "docNumber",
    },
    {
      title: "Телефон",
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Адрес",
      dataIndex: "address",
      key: "address",
    },
    {
      title: "Действия",
      key: "actions",
      render: (_, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
          />
          <Button
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(record.docNumber)}
          />
        </Space>
      ),
    },
  ];

  const showModal = () => {
    setCurrentClient(null);
    form.resetFields();
    setIsModalVisible(true);
  };

  const handleEdit = (client) => {
    setCurrentClient(client);
    form.setFieldsValue(client);
    setIsModalVisible(true);
  };

  const handleDelete = (docNumber) => {
    Modal.confirm({
      title: "Удалить клиента?",
      content: "Вы уверены, что хотите удалить этого клиента?",
      okText: "Да",
      cancelText: "Нет",
      onOk: () => {
        setClients(clients.filter((client) => client.docNumber !== docNumber));
        message.success("Клиент удален");
      },
    });
  };

  const handleOk = () => {
    form
      .validateFields()
      .then((values) => {
        if (currentClient) {
          // Редактирование существующего клиента
          setClients(
            clients.map((client) =>
              client.docNumber === currentClient.docNumber
                ? { ...client, ...values }
                : client,
            ),
          );
          message.success("Клиент обновлен");
        } else {
          // Добавление нового клиента
          const newClient = {
            ...values,
            docNumber: Math.floor(Math.random() * 10000000000).toString(), // Генерация случайного номера документа
          };
          setClients([...clients, newClient]);
          message.success("Клиент добавлен");
        }
        setIsModalVisible(false);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="page-wrapper">
      <div className="content">
        <div style={{ padding: "24px" }}>
          <div style={{ marginBottom: "16px" }}>
            <Button type="primary" icon={<PlusOutlined />} onClick={showModal}>
              Добавить клиента
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={clients}
            rowKey="docNumber"
            bordered
          />

          <Modal
            title={currentClient ? "Редактировать клиента" : "Добавить клиента"}
            visible={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            okText={currentClient ? "Обновить" : "Добавить"}
            cancelText="Отмена"
          >
            <Form form={form} layout="vertical" name="client_form">
              <Form.Item
                name="name"
                label="Название компании"
                rules={[
                  {
                    required: true,
                    message: "Пожалуйста, введите название компании",
                  },
                ]}
              >
                <Input placeholder="ООО 'Ромашка'" />
              </Form.Item>

              <Form.Item
                name="docNumber"
                label="Номер документа"
                rules={[
                  {
                    required: true,
                    message: "Пожалуйста, введите номер документа",
                  },
                ]}
              >
                <Input placeholder="1234567890" />
              </Form.Item>

              <Form.Item
                name="phone"
                label="Телефон"
                rules={[
                  { required: true, message: "Пожалуйста, введите телефон" },
                ]}
              >
                <Input placeholder="+7 (XXX) XXX-XX-XX" />
              </Form.Item>

              <Form.Item
                name="address"
                label="Адрес"
                rules={[
                  { required: true, message: "Пожалуйста, введите адрес" },
                ]}
              >
                <Input.TextArea
                  placeholder="г. Москва, ул. Примерная, д. 1"
                  rows={3}
                />
              </Form.Item>
            </Form>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default ClientPage;
